import { DeleteOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

export const FLIGHT_MODEL_MANAGEMENT_COLUMNS_HEAD = (onDelete, selectedFlightModel) => [
  {
    title: "Serial No.",
    dataIndex: "serial_no",
    align: "left",
  },
  {
    title: "Flight Name",
    dataIndex: "name",
    align: "left",
  },
  {
    title: "Action",
    key: "actions",
    align: "right",
    width: "120px",
    render: (_, record) => {
      const isSelected = record.name === selectedFlightModel;
      return (
        <Tooltip
          title={
            isSelected
              ? "Currently selected flight model cannot be deleted"
              : "Delete Flight Model"
          }
          color={isSelected ? undefined : "#F84646"}
        >
          <DeleteOutlined
            style={{
              backgroundColor: isSelected
                ? "rgba(0, 0, 0, 0.06)"
                : "rgba(248, 70, 70, 0.15)",
              color: isSelected ? "rgba(0, 0, 0, 0.25)" : "#F84646",
              borderRadius: "3px",
              padding: "6px",
              fontSize: "16px",
              cursor: isSelected ? "not-allowed" : "pointer",
            }}
            onClick={() => !isSelected && onDelete?.(record)}
          />
        </Tooltip>
      );
    },
  },
];

export const ADD_FLIGHT_MODEL_INITIAL_OBJECT = {
  name: "",
  errorFieds: {
    name: "",
  },
};
